/**
 * Consulta "Síntese de alocações" (`GET /allocations/summary`): matriz de centro
 * de custo (uma linha por `contrato_cliente`, rótulo = código + nome do contrato)
 * × N semanas, com a projeção de headcount por unidade. Sem custo no v1 (T12).
 */
export const SUMMARY_HORIZONS = ['6', '8', '12'] as const;

export type SummaryHorizon = (typeof SUMMARY_HORIZONS)[number];

export type SummaryUnit = 'BR' | 'US';

export type SummaryFilters = {
  /** `YYYY-MM-DD`; ausente = hoje (o back devolve a data usada em `date`). */
  date?: string;
  weeks: number;
};

/** Semana projetada: `startDate` na segunda, `endDate` no domingo. */
export type SummaryWeek = {
  index: number;
  startDate: string;
  endDate: string;
};

export type SummaryRow = {
  costCenterId: number;
  /** `contrato_cliente.cod_contrato`; pode ser nulo. */
  contractCode: number | null;
  /** `contrato_cliente.nome`. */
  contractName: string;
  unitCode: SummaryUnit;
  /** COUNT de profissionais vigentes por semana, alinhado a `weeks`. */
  headcountByWeek: number[];
};

/** Subtotal por unidade; só vem a unidade PRESENTE nos dados (pode faltar BR ou US). */
export type SummarySubtotal = {
  unitCode: SummaryUnit;
  headcountByWeek: number[];
};

export type SummaryResponse = {
  date: string;
  weeks: SummaryWeek[];
  rows: SummaryRow[];
  subtotals: SummarySubtotal[];
  totalByWeek: number[];
};
